// JS of FindClosest
import { APP_CONFIG } from '../../shared/global/base';
import haversine from 'haversine';
import { goFish } from '../../shared/global/api';
import { Loader as MapLoader } from '@googlemaps/js-api-loader';

const DEFAULT_MAX_DISTANCE = 100;

const G_LOADER = new MapLoader({
    apiKey: APP_CONFIG.google.map,
    version: 'quarterly'
});

/**
 *
 * @param address - [city, street , street number, home number]
 * @param maxdistance
 */
export async function findClosest(address: string[], maxdistance = DEFAULT_MAX_DISTANCE): Promise<LocalDistanceData> {
    // Get default if 0 or undefined
    const max = maxdistance || DEFAULT_MAX_DISTANCE;

    // Geocode url and container
    const streetString = address.map( s => s.trim()).filter(s => s).reverse().join(' ');
    let geocodeData: haversine.CoordinateLongitudeLatitude;

    // Get mapdata first
    const mapdata: LocalsList = await goFish({ api: 'list' });
    if (!mapdata.Data || !mapdata.Data.length) {
        return { Local: undefined, Distance: 0 }
    }

    // If locals data are fine than geocode address
    try {
        await G_LOADER.load();
        const geocoder = new google.maps.Geocoder();
        await new Promise((resolve, reject) => {
            geocoder.geocode( { address: streetString }, (results, status) => {
                if (status == 'OK') {
                    geocodeData = {
                        latitude: results[0].geometry.location.lat(),
                        longitude: results[0].geometry.location.lng()
                    };
                    resolve(geocodeData);
                } else {
                    console.warn('Tried geocode but', status);
                    reject();
                }
            });
        });
    } catch (e) {
        return { Local: undefined, Distance: 0 }
    }

    // Calculate distances
    const fullDataArr = mapdata.Data.map((item) => {
        if (item && item.Location) {
            const singlePlace = {
                latitude: item.Location.Lat,
                longitude: item.Location.Lng
            }
            // Save for later sorting/filtering
            return {
                // Without treshold as option 'dist' is number always
                Distance: haversine<number>(geocodeData, singlePlace),
                Local: item
            }
        }
        // Just return 0, it will be filtered out later
        return {
            Distance: 0,
            Local: undefined
        }
    })
    // Distance is more than 0 and less or equal than max and pickup available
    .filter(local => local.Distance > 0 && local.Distance <= max && local.Local.IsPickupActive)
    // Get nearest
    .sort((a, b) => a.Distance - b.Distance);

    if (!fullDataArr.length) {
        return { Local: undefined, Distance: 0 }
    }

    // Closest local data
    return fullDataArr[0];
}
